<template>
    <div class="dataTable">
        <LoaderComponent v-if="isLoading && caracteristiques.length === 0" />
        <div v-else class="datatable-container">
            <DataTable
                :isLoading="isLoading"
                :not-sticky="true"
                :tableData="caracteristiques"
                :tableHeader="tableHeader"
            />
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { store } from '@/plugins/store';
import { CaracteristiqueArticle } from '@/models/CaracteristiqueArticle';
import DataTable from '@/components/ui-components/DataTable.vue';
import LoaderComponent from '@/components/ui-components/LoaderComponent.vue';
import { EquipementAction } from '@/modules/Equipements/store/actions-types';

export default defineComponent({
    name: 'CaracteristiquesTab',
    components: { LoaderComponent, DataTable },
    props: {
        phaseId: {
            type: Number,
            required: true,
        },
    },

    beforeMount() {
        store.dispatch(`equipementState/${EquipementAction.GET_CARACTERISTIQUES_EQUIPEMENT}`, this.phaseId);
    },
    computed: {
        tableHeader() {
            return store.getters['equipementState/getCaracteristiquesHeaders'];
        },
        isLoading(): boolean {
            return store.getters['equipementState/getCaracteristiquesLoading'];
        },
        caracteristiques(): [] {
            return store.getters['equipementState/getCaracteristiquesData'].map((c: CaracteristiqueArticle) => {
                return {
                    libelle: c.libelle,
                    valeur: c.valeur,
                    uniteMesure: c.uniteMesure,
                };
            });
        },
    },
});
</script>
<style scoped></style>
